export const shelfBrackets = [
    {
        name: 'gbr_30',
        height: 0.1,
        width: 0.1,
        depth: 0.1,
        rotation: [ -7.0086, 0, 0 ],
        shelfPosition: [ 0,-0.002,0.01 ],
        rodHolderPosition: [ 0,-0.008,0.267 ],
    },
    {
        name: 'gbr_40',
        height: 0.1,
        width: 0.1,
        depth: 0.1,
        shelfPosition: [ 0,-0.002,0.01 ],
        rodHolderPosition: [ 0,-0.008, 0.267 ],
    },
    {
        name: 'gbr_50',
        height: 0.1,
        width: 0.1,
        depth: 0.1,
        rotation: [ -5.60423, 0, 0 ],
        offsets: [ 0, -0.012, 0 ],
        shelfPosition: [ 0, -0.014, 0.002 ],
        rodHolderPosition: [ 0,-0.008,0.267 ],
    },
];

export const defaultShelfBracketOffsets = [ 0,0,0 ] as const;

export const defaultShelfBracketRotation = [ 0,0,0 ] as const;
